import i18n from '@/lib/i18n';
import { buildPrintDocument, type PrintDocumentOptions } from '@/lib/print-document-html';

export { escapeHtmlText } from '@/lib/print-document-html';

/**
 * POS-I240: open a printable document in a popup through the shared builder (base style, escaped
 * title, body, and the product's Powered by footer on every page). Returns false when the popup
 * was blocked, so the caller can show its own toast.
 */
export function openPrintWindow(
  opts: Omit<PrintDocumentOptions, 'poweredByLabel' | 'dir'> & { width?: number; height?: number },
): boolean {
  const win = window.open('', '_blank', `width=${opts.width ?? 900},height=${opts.height ?? 700}`);
  if (!win) return false;
  const label = i18n.t('poweredBy', { ns: 'common', defaultValue: 'Powered by' });
  const dir = i18n.dir?.() === 'rtl' ? 'rtl' : 'ltr';
  win.document.write(buildPrintDocument({ ...opts, poweredByLabel: label, dir }));
  win.document.close();
  return true;
}
